export default __webpack_public_path__ + "static/applet-24-set-1-f9855a4df01a3794a06384c00fd3c673.webp";